import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ReviewAttemptDetails from './ReviewAttemptDetails';

const API_BASE = (process.env.REACT_APP_API_BASE || '/api').replace(/["']/g, '').replace(/\/+$/, '');

export default function ParentResults() {
  const { assignmentId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadResults();
  }, [assignmentId]);

  const loadResults = async () => {
    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        navigate('/parent/login');
        return;
      }

      const res = await fetch(`${API_BASE}/parent/review/attempts/${assignmentId}/details`, {
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        throw new Error(errData.error || 'Failed to fetch results');
      }
      
      const result = await res.json();
      setData(result);
    } catch (err) {
      console.error('❌ Load results error:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: 40, textAlign: 'center', minHeight: '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div>⏳ Loading exam results...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ maxWidth: 600, margin: '40px auto', padding: 24 }}>
        <div style={{ padding: 20, background: '#f8d7da', color: '#721c24', borderRadius: 6, marginBottom: 20, border: '1px solid #f5c6cb' }}>
          ❌ <strong>Error:</strong> {error}
        </div>
        <button 
          onClick={() => navigate('/parent/dashboard')} 
          style={{ padding: '10px 16px', background: '#6c757d', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}
        >
          ← Back to Dashboard
        </button>
      </div>
    );
  }

  if (!data || !data.assignment) {
    return (
      <div style={{ maxWidth: 600, margin: '40px auto', padding: 24 }}>
        <div style={{ padding: 20, background: '#fff3cd', color: '#856404', borderRadius: 6, marginBottom: 20, border: '1px solid #ffeeba' }}>
          ⚠️ No result data available for this attempt.
        </div>
        <button 
          onClick={() => navigate('/parent/dashboard')} 
          style={{ padding: '10px 16px', background: '#6c757d', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}
        >
          ← Back to Dashboard
        </button>
      </div>
    );
  }

  // Reuse the exact same admin component, passing the data directly!
  // The ReviewAttemptDetails component will handle the rendering based on the data structure.
  return <ReviewAttemptDetails initialData={data} isParentView={true} />;
}